import { MapTo } from '@adobe/cq-react-editable-components';
import Loadable from '../../../../utils/loadable';
import { isFuncComp } from '../../../../components/common/Helpers';

const shippingOptions = Loadable(() =>
  !isFuncComp() ? import('../../containers/web/shippingOptions') : import('../../FuncComponnetContainers/web/shippingOptions'),
);

export default MapTo('vcg/components/soe-home/react/shippingOptions')(shippingOptions);
